export enum LightReturnControlName {
  SubtypeReason = 'SubtypeReason',
}
